import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function MediaCenter() {
  const { t } = useTranslation();
  const facts = t('media.facts', { returnObjects: true }) || [];
  return (
    <InfoPage
      eyebrow={t('info.company')}
      title={t('media.title')}
      subtitle={t('media.subtitle')}
    >
      <h2>{t('media.pressInquiries')}</h2>
      <p>
        {t('media.pressCopyBefore')}{' '}
        <a href="mailto:press@starviewcinema.com">press@starviewcinema.com</a>
        {t('media.pressCopyAfter')}
      </p>

      <h2>{t('media.brandAssets')}</h2>
      <p>{t('media.brandAssetsCopy')}</p>

      <h2>{t('media.factSheet')}</h2>
      <div className="info-grid">
        {facts.map((f) => (
          <div key={f.name} className="info-card">
            <h3>{f.name}</h3>
            <p>{f.desc}</p>
          </div>
        ))}
      </div>
    </InfoPage>
  );
}
